import LoadingIcon from '@/assets/icons/loading.svg?react';
import { type IconComponentProps } from '@/components/types';
import { primaryDarkGrey } from '@/styles';

import styles from './styles.module.scss';

export function LoadingScreen({
  width = 52,
  height = 46,
  color = primaryDarkGrey,
}: IconComponentProps) {
  return (
    <div className={styles.container}>
      <LoadingIcon
        className={styles.icon}
        width={width}
        height={height}
        color={color}
      />
    </div>
  );
}
